// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__Gn5fK","input":"styles_input__7nbR6","btn_submit":"styles_btn_submit__S+jNJ"};